import React from 'react';
import { GridColumn } from "../../../layout/GridColumn";
import { GridRow } from "../../../layout/GridRow";
import { Paragraph } from "../../../typography/Paragraph";
export var getMobileRateRowMarkup = function getMobileRateRowMarkup(rate, rateHeading, key) {
  return React.createElement(GridRow, {
    columns: 2,
    key: key
  }, React.createElement(GridColumn, {
    floated: "left"
  }, React.createElement(Paragraph, {
    weight: "heavy"
  }, rateHeading)), React.createElement(GridColumn, {
    floated: "right",
    textAlign: "right"
  }, rate));
};